
import { defineComponent, computed } from 'vue'
import { useInvoicesModule } from '@/modules/invoices'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';

export default defineComponent({
    name: 'invoices-show-external-log',
    props: {
        invoiceId: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const { dialogRef, onDialogCancel } = useDialogPluginComponent()
        const { invoicingExternalLogs, getInvoicingExternalLogs } = useInvoicesModule()
        getInvoicingExternalLogs(props.invoiceId)

        const lastEntry = computed(() => {
            const lastIndex = invoicingExternalLogs.value.count - 1
            return invoicingExternalLogs.value.logEntries[lastIndex]
        })

        return {
            dialogRef,
            onDialogCancel,
            invoicingExternalLogs,
            lastEntry
        }
    }
})
